import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatPrice } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Plus, Check } from "lucide-react";

export const ArtworkCard = ({ artwork, index = 0 }) => {
  const { addItem, items } = useCart();
  const inCart = items.find((i) => i.id === artwork.id);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
      className="group"
      data-testid={`artwork-card-${artwork.id}`}
    >
      <Link to={`/oeuvre/${artwork.id}`} className="block overflow-hidden bg-[#0d0d0d] relative aspect-[4/5]">
        <img
          src={artwork.image_url}
          alt={artwork.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {artwork.sold && (
          <div className="absolute top-4 left-4 bg-[#E11D48] text-white text-[10px] uppercase tracking-widest px-3 py-1">
            Vendu
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </Link>
      <div className="flex items-start justify-between mt-4 gap-4">
        <div>
          <Link to={`/oeuvre/${artwork.id}`}>
            <h3 className="font-display text-xl text-white leading-tight hover:text-[#60a5fa] transition-colors">
              {artwork.title}
            </h3>
          </Link>
          <p className="text-zinc-500 text-sm mt-1">{artwork.artist_name}</p>
          <p className="text-zinc-300 text-sm mt-2">{formatPrice(artwork.price)}</p>
        </div>
        {!artwork.sold && (
          <button
            data-testid={`add-to-cart-${artwork.id}`}
            onClick={() => addItem(artwork)}
            className="shrink-0 mt-1 h-10 w-10 flex items-center justify-center border border-white/15 text-white hover:bg-[#2563EB] hover:border-[#2563EB] transition-all"
            aria-label="Ajouter au panier"
          >
            {inCart ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
          </button>
        )}
      </div>
    </motion.div>
  );
};
